import { RouteColorsList, colorSwatches } from "@mysnowscape/snow-lib";

export const colors = RouteColorsList;

export { colorSwatches };
